/**
 * Smooth open and close for every <details> accordion the theme renders
 * (.cc-accordion__item on product pages, .cc-faq__item in the FAQ). The height
 * is animated with the Web Animations API; reduced-motion users get the
 * instant native toggle.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function animateDetails(details, summary, body) {
  summary.addEventListener('click', (event) => {
    if (reduceMotion.matches || details.dataset.animating === 'true') return;
    event.preventDefault();
    details.dataset.animating = 'true';
    details.style.overflow = 'hidden';
    const start = details.offsetHeight;
    if (details.open) {
      const end = summary.offsetHeight;
      details.animate({ height: [`${start}px`, `${end}px`] }, { duration: 260, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }).onfinish = () => {
        details.open = false;
        finish(details);
      };
    } else {
      details.open = true;
      const end = summary.offsetHeight + body.offsetHeight;
      details.animate({ height: [`${start}px`, `${end}px`] }, { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }).onfinish = () => finish(details);
    }
  });
}

function finish(details) {
  details.dataset.animating = 'false';
  details.style.overflow = '';
  details.style.height = '';
}

function init(root = document) {
  root.querySelectorAll('details.cc-accordion__item, details.cc-faq__item').forEach((details) => {
    if (details.dataset.ccAccordion) return;
    const summary = details.querySelector('summary');
    const body = summary?.nextElementSibling;
    if (!summary || !body) return;
    details.dataset.ccAccordion = 'true';
    animateDetails(details, summary, body);
  });
}

init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
